import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {getAmplitudeViewItemEventProperties} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {IPersonalizedPropertyCard} from "../types/IPersonalizedHomepage";

interface IRecentlyViewedItem {
    property: IPropertyDetail;
    card: IPersonalizedPropertyCard;
    /** Position in the whole carousel, retained when hidden tiles are excluded. */
    index: number;
}

export const RECENTLY_VIEWED_ITEM_LIST_NAME = "Ostatnio oglądane oferty";

const recentlyViewedListContext = {
    item_list_id: null,
    item_list_name: RECENTLY_VIEWED_ITEM_LIST_NAME,
    location: "homepage"
};

export const trackPersonalizedHomepageRecentlyViewedList = (params: {items: IRecentlyViewedItem[]}) => {
    if (params.items.length === 0) {
        return;
    }

    trackAmplitudeEvent("view_item_list", {
        ...recentlyViewedListContext,
        products: params.items.map(getRecentlyViewedEventProperties)
    });
};

export const trackPersonalizedHomepageRecentlyViewedSelect = (params: IRecentlyViewedItem) => {
    trackAmplitudeEvent("select_item", {
        ...recentlyViewedListContext,
        ...getRecentlyViewedEventProperties(params)
    });
};

const getRecentlyViewedEventProperties = ({property, card, index}: IRecentlyViewedItem) => {
    const eventProperties = getAmplitudeViewItemEventProperties({offer: property.offer, property});
    const price = getDisplayedPrice(card.priceLabel);
    const pricePerSquareMeter = getDisplayedPrice(card.pricePerSquareMeterLabel);

    return {
        ...eventProperties,
        variant_floor: card.floorLabel,
        price,
        currency: price === null ? null : eventProperties.currency,
        ...(price !== null && pricePerSquareMeter !== null ? {price_m2: pricePerSquareMeter} : {}),
        index
    };
};

/** Read the displayed amount, including UI rounding; "Zapytaj o cenę" has no amount. */
const getDisplayedPrice = (label: string | null): number | null => {
    const amount = label?.match(/^\s*(\d[\d\s]*(?:[,.]\d+)?)/)?.[1];

    return amount ? Number(amount.replace(/\s/g, "").replace(",", ".")) : null;
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {getAmplitudeViewItemEventProperties} from "../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {IPersonalizedPropertyCard} from "../types/IPersonalizedHomepage";

interface IRecentlyViewedItem {
    property: IPropertyDetail;
    card: IPersonalizedPropertyCard;
    /** Position in the whole carousel, retained when hidden tiles are excluded. */
    index: number;
}

export const RECENTLY_VIEWED_ITEM_LIST_NAME = "Ostatnio oglądane oferty";

const recentlyViewedListContext = {
    item_list_id: null,
    item_list_name: RECENTLY_VIEWED_ITEM_LIST_NAME,
    location: "homepage"
};

export const trackPersonalizedHomepageRecentlyViewedList = (params: {items: IRecentlyViewedItem[]}) => {
    if (params.items.length === 0) {
        return;
    }

    trackAmplitudeEvent("view_item_list", {
        ...recentlyViewedListContext,
        products: params.items.map(getRecentlyViewedEventProperties)
    });
};

export const trackPersonalizedHomepageRecentlyViewedSelect = (params: IRecentlyViewedItem) => {
    trackAmplitudeEvent("select_item", {
        ...recentlyViewedListContext,
        ...getRecentlyViewedEventProperties(params)
    });
};

const getRecentlyViewedEventProperties = ({property, card, index}: IRecentlyViewedItem) => {
    const eventProperties = getAmplitudeViewItemEventProperties({offer: property.offer, property});
    const price = getDisplayedPrice(card.priceLabel);
    const pricePerSquareMeter = getDisplayedPrice(card.pricePerSquareMeterLabel);

    return {
        ...eventProperties,
        variant_floor: card.floorLabel,
        price,
        currency: price === null ? null : eventProperties.currency,
        ...(price !== null && pricePerSquareMeter !== null ? {price_m2: pricePerSquareMeter} : {}),
        index
    };
};

/** Read the displayed amount, including UI rounding; "Zapytaj o cenę" has no amount. */
const getDisplayedPrice = (label: string | null): number | null => {
    const amount = label?.match(/^\s*(\d[\d\s]*(?:[,.]\d+)?)/)?.[1];

    return amount ? Number(amount.replace(/\s/g, "").replace(",", ".")) : null;
};
